import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const getFlowCharts = async (flowDeviceId) => {
  const result = await tryGet(`/flowCharts?flowDeviceId=${flowDeviceId}`);
  return result.data;
};

export const getFlowChart = async (flowChartId) => {
  const result = await tryGet(`/flowCharts/${flowChartId}`);
  return result.data;
};

export const updateFlowCharts = async (flowCharts) => {
  const result = await tryPut('/flowCharts/batch', flowCharts);
};
export const addFlowCharts = async (flowCharts) => {
  console.log(flowCharts);
  const result = await tryPost('/flowCharts/batch', flowCharts);
};

export const deleteFlowCharts = async (flowChartIds) => {
  const result = await tryPost('/flowCharts/batch/delete', flowChartIds);
};
